module.exports = __webpack_public_path__ + "static/3-d28c3e961fd66283ca6defc578e0a60a.jpg";